@let expanded = isExpanded() || forceExpand();
<div
  class="template-select-expansion-panel"
  [class.is-expanded]="expanded">
  <div class="panel-header">
    <div
      class="expansion-control"
      (click)="toggleExpansion()">
      <i
        class="icon icon-caret_medium_down"
        [class.rotated]="isExpanded()"
        style="font-size: 24px"></i>
    </div>
    <div class="label">{{ label() }}</div>
    <div class="template-count">{{ templates().length }}</div>
  </div>
  <div class="panel-content">
    @for (template of templates(); track template.uId) {
      <div
        class="template-selector"
        (click)="onTemplateSelected.emit(template.uId)">
        <div class="label">{{ template.name }}</div>
        @if (!!template.badgeText) {
          <div class="template-type-badge">{{ template.badgeText }}</div>
        }
      </div>
    }
  </div>
</div>